import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import { CheckboxWithLabel, TextField, } from "formik-material-ui";
import * as Yup from "yup";
import { useProductTypes, useReportDefinitions } from "../../../projectManagementQueries";
import LSDBSelectField from "../../../../common/LSDBSelectField";
import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";
import { Delete } from "@material-ui/icons";

import { report } from "process";

import { usePostFile } from "../../../../common/services/fileServices";
import { useFetchContext } from "../../../../common/FetchContext";
import { TsdDefineDataDialog } from "./TsdDefineDataDialog";
import { toast } from "react-toastify";
import LSDBFormikAutocompleteField from "../../../../common/LSDBFormikAutocompleteField";

// const [value, setValue] = React.useState<string | null>("");
// const ReportType = ["Module Intake Report", "Factory witness report", "Module IAM Report", "Inverter Field Testing ", "Engineering Report",];
// const ProductType = ["Modules", "Racking", "Inverter", "Optimizer ", "Power Electronics ", "Energy Storage System"];
type EditingProps = {
  editingMode: boolean;
  procedureDefinition: ReportExecutionOrder;
};
type ReportDefinitionValues = {
  execution_group_name: string | number;
  report_definition_id: string | number;
  execution_group_number: string | number;
  product_definition_id: string | number;
  test_definition_id: string | number;
};
const ReportDefinitionFormDialog = ({
  dialogIsOpen,
  onCloseDialog,
  onSubmitProcedureDefinition,
  editingInfo,
}: {
  dialogIsOpen: boolean;
  onCloseDialog: () => void;
  onSubmitProcedureDefinition: (
    existingProcedureDefinition: ReportExecutionOrder | undefined,
    procedureDefinition: ReportExecutionOrder
  ) => void;
  editingInfo?: EditingProps;
}) => {
  const [valueFromChild, setValueFromChild] = React.useState<string | null>("");
  const [tsdId, setTsdId] = React.useState<string | null>("");
  const [Reportvalue, setReportValue] = React.useState<string | null>("");
  const ReportType = ["Module Intake Report", "Factory witness report", "Module IAM Report", "Inverter Field Testing ", "Engineering Report",];
  const ProductType = ["Modules", "Racking", "Inverter", "Optimizer ", "Power Electronics ", "Energy Storage System"];
  const reportDefinitions = useReportDefinitions(true);
  const productTypes = useProductTypes(true);
  const [files, setFiles] = React.useState([]);
  const { mutateAsync: mutatePostFile } = usePostFile();
  const { authAxios } = useFetchContext();
  // const fileInputRef = useRef<HTMLInputElement>(null);
  // const handleFileUpload = async (item: any) => {
  //   console.log(item)
  //   fileInputRef.current?.click()
  // };
  // const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const uploadedFiles = event.target.files;
  //   if (uploadedFiles) {
  //     setFiles(uploadedFiles as any);
  //   }
  // }

  useEffect(() => {
    if (dialogIsOpen) {
      setFiles([]);
      setValueFromChild("");
    }
  }, [dialogIsOpen]);
  const [openTsd, setOpenTsd] = useState(false);
  const handleAlert = () => {
    setOpenTsd(true);
  };
  const handleClose = (value: string, id: string) => {
    // If value is an object (like MouseEvent), ignore it
    if (typeof value === 'string') {
      setValueFromChild(value);
      setTsdId(id);
    } else {
      console.warn('handleClose received a non-string value:', value);
    }

    setOpenTsd(false);
  };
  return (
    <>
      <Dialog open={dialogIsOpen} onClose={onCloseDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          {editingInfo && editingInfo.editingMode
            ? "Edit the Report Definition"
            : "Add a new Report Definition"}
        </DialogTitle>
        {reportDefinitions.isSuccess && (
          <Formik
            initialValues={
              editingInfo && editingInfo.editingMode && editingInfo.procedureDefinition
                ? {
                  execution_group_name: editingInfo.procedureDefinition.execution_group_name,
                  report_definition_id: editingInfo.procedureDefinition.report_definition_id,
                  execution_group_number: editingInfo.procedureDefinition.execution_group_number,
                  product_definition_id: editingInfo.procedureDefinition.product_definition_id,
                  test_definition_id: editingInfo.procedureDefinition.test_definition_id,
                  data_ready_status: editingInfo.procedureDefinition.data_ready_status,
                }
                : {
                  execution_group_name: "",
                  report_definition_id: 0,
                  execution_group_number: 0,
                  product_definition_id: 0,
                  test_definition_id: 0,
                }
            }
            validationSchema={Yup.object({
              execution_group_name: Yup.string()
                .required("Execution Group Name is required")
                .max(128, "Execution Group Name can't be more than 128 characters long"),
              execution_group_number: Yup.number().required("Execution Group Number is required"),
              product_definition_id: Yup.number().moreThan(0, "Select an appropriate Procedure Definition"),
              report_definition_id: Yup.number().moreThan(0, "Select an appropriate Procedure Definition"),
            })}
            onSubmit={async (values: ReportDefinitionValues, { setSubmitting }) => {


              // Validate Data Ready Status
              if (!valueFromChild || valueFromChild.trim() === "") {
                toast.warning("Please define Data Ready Status");
                setSubmitting(false);
                return;
              }

              let previousProcedureDefinition = editingInfo?.procedureDefinition;
              // let fileUrl = "";
              // if (files.length > 0) {
              //   for (let file of files) {
              //   const uploaded = await mutatePostFile({ authAxios, file });
              //   fileUrl = uploaded.id;
              //   }
              // }
              const newProcedureDefinition = {
                execution_group_name: values.execution_group_name,
                report_definition_id: values.report_definition_id,
                execution_group_number: values.execution_group_number,
                product_definition_id: values.product_definition_id,
                test_definition_id: tsdId || 0,
                procedure_definition_name: reportDefinitions.data.find(
                  (procedureDefinition) =>
                    procedureDefinition.id === values.report_definition_id
                )!.name,
                // azure_file_id: fileUrl || undefined,
                data_ready_status: valueFromChild || undefined,
              };
              onSubmitProcedureDefinition(previousProcedureDefinition, newProcedureDefinition);
              setSubmitting(false);
              onCloseDialog();
            }}
          >
            {({ submitForm, errors }) => (
              <>
                <DialogContent>
                  <Paper>
                    <Form>
                      <Grid container direction="row" justifyContent="center" alignItems="center" style={{ paddingBottom: 32 }}>
                        <Grid item container justifyContent="center" spacing={1} xs={12}>
                          <Grid item xs={4}>
                            <Field
                              id="execution_group_name"
                              name="execution_group_name"
                              type="text"
                              component={TextField}
                              fullWidth
                              InputLabelProps={{ required: true }}
                              style={{ marginBottom: 32 }}
                              label="Report Title"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Field
                              id="execution_group_number"
                              name="execution_group_number"
                              type="number"
                              InputLabelProps={{ required: true }}
                              component={TextField}
                              fullWidth
                              style={{ marginBottom: 32 }}
                              label="Report Order Number"
                            />
                          </Grid>
                        </Grid>
                        <Grid item container justifyContent="center" spacing={1} xs={12}>
                          <Grid item xs={4}>
                            {/* <LSDBSelectField
                              fieldId="report_definition_id"
                              fieldName="report_definition_id"
                              fieldDisplayName="Report Definition *"
                              fullWidth
                              errors={errors.execution_group_name}
                              options={reportDefinitions.data}
                              mappingFunction={(procedureDefinition) => (
                                <MenuItem value={procedureDefinition.id}>
                                  {procedureDefinition.name}
                                </MenuItem>
                              )}
                            /> */}
                            <LSDBFormikAutocompleteField
                              fieldId="report_definition_id"
                              fieldName="report_definition_id"
                              fieldDisplayName="Report Definition"
                              options={reportDefinitions.data}
                              getOptionLabel={(reportDefinition: any) => reportDefinition.name}
                              getOptionValue={(reportDefinition: any) => reportDefinition.id}
                              fullWidth={true}
                              variant="standard"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            {/* <LSDBSelectField
                              fieldId="product_definition_id"
                              fieldName="product_definition_id"
                              fieldDisplayName="Product Type *"
                              fullWidth
                              errors={errors.execution_group_name}
                              options={productTypes.data}
                              mappingFunction={(procedureDefinition) => (
                                <MenuItem value={procedureDefinition.id}>
                                  {procedureDefinition.name}
                                </MenuItem>
                              )}
                            /> */}
                            <LSDBFormikAutocompleteField
                              fieldId="product_definition_id"
                              fieldName="product_definition_id"
                              fieldDisplayName="Product Type"
                              options={productTypes.data}
                              getOptionLabel={(productType: any) => productType.name}
                              getOptionValue={(productType: any) => productType.id}
                              fullWidth={true}
                              variant="standard"
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} justifyContent="center">

                          <Grid item xs={12}>
                            <Grid container justifyContent="center">
                              {/* <Grid item xs={8}>
                              <Typography variant="h5" color="primary">
                                Upload File
                                <img
                                  onClick={handleFileUpload}
                                  src="/file_upload.svg"
                                  alt="Upload Icon"
                                  width="30"
                                  height="30"
                                  style={{ cursor: 'pointer', marginLeft: '10px', verticalAlign: 'middle' }}
                                />
                              </Typography>
                              <input
                                ref={fileInputRef}
                                type="file"
                                style={{ display: 'none' }}
                                accept=".docx"
                                onChange={handleFilePicked}
                              />
                              {files.length !== 0 && (
                                <div style={{ position: "relative", display: "inline-block", marginTop: '15px' }}>
                                  <img src="/file_icon.png" alt="Uploaded File Icon" height={150} width={130} />
                                  <IconButton
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      right: "5px",
                                      background: "lightgray",
                                      color: "black",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "40px",
                                      height: "40px",
                                    }}
                                    onClick={() => setFiles([])}
                                  >
                                    <Delete />
                                  </IconButton>
                                </div>
                              )}
                            </Grid> */}
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid container justifyContent="center">
                              <Grid item xs={8}>
                                <Typography variant="h5">Data Ready Status *</Typography>
                                <Grid container spacing={1} alignItems="center" style={{ marginTop: '10px' }}>
                                  <Grid item xs={1}>
                                    <Button variant="contained" color="primary" onClick={handleAlert}>
                                      Define
                                    </Button>
                                  </Grid>

                                  {editingInfo?.procedureDefinition?.data_ready_status && !valueFromChild && (
                                    <Grid item xs={12}>
                                      <Typography>
                                        {editingInfo.procedureDefinition.data_ready_status}
                                      </Typography>
                                    </Grid>
                                  )}

                                  {valueFromChild && (
                                    <Grid item xs={6} style={{ marginLeft: '50px' }}>
                                      <Typography variant="h6" style={{ fontSize: '16px' }}>{valueFromChild}</Typography>
                                    </Grid>
                                  )}

                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Form>
                  </Paper>
                </DialogContent>
                <DialogActions>
                  <Button variant="outlined" color="secondary" onClick={onCloseDialog}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="primary" onClick={submitForm}>
                    {editingInfo && editingInfo.editingMode
                      ? "Update Report Definition"
                      : "Add Report Definition"}
                  </Button>
                </DialogActions>
              </>
            )}
          </Formik>
        )}
      </Dialog>
      {openTsd && (
        <TsdDefineDataDialog
          openTsd={openTsd} handleClose={handleClose}


        />
      )}

    </>

  );
};
export default ReportDefinitionFormDialog;